<div class="detail-content">
  @if (readonly()) {
    <div tuiNotification appearance="info" size="m" class="readonly-notice">
      Default category limits are fixed and cannot be edited.
    </div>
  }

  <div class="filters">
    <tui-textfield tuiChevron [stringify]="stringifyCategory" [tuiTextfieldCleaner]="false" class="category-picker">
      <label tuiLabel>Category</label>
      <input tuiSelect [ngModel]="selectedCategory()" (ngModelChange)="selectedCategory.set($event)" />
      <tui-data-list-wrapper *tuiDropdown [items]="categoryOptions()" />
    </tui-textfield>

    <tui-textfield tuiChevron [stringify]="stringify" [tuiTextfieldCleaner]="false" class="sport-picker">
      <label tuiLabel>Sport</label>
      <input tuiSelect [ngModel]="selectedSport()" (ngModelChange)="onSportChange($event)" />
      <tui-data-list-wrapper *tuiDropdown [items]="sports()" />
    </tui-textfield>

    <tui-textfield tuiChevron class="metric-picker">
      <label tuiLabel>Metric</label>
      <input tuiSelect [ngModel]="selectedMetric()" (ngModelChange)="selectedMetric.set($event)" />
      <tui-data-list-wrapper *tuiDropdown [items]="metricNames()" />
    </tui-textfield>
  </div>

  @if (!selectedCategory()) {
    @if (isLoadingCategories()) {
      <tui-loader size="l" />
    } @else {
      <div tuiNotification appearance="info" size="m">Pick a category to view its limits.</div>
    }
  } @else if (isLoadingSports() || isLoadingLimits()) {
    <tui-loader size="l" />
  } @else if (!selectedSport()) {
    <div tuiNotification appearance="info" size="m">Pick a sport to view its limits.</div>
  } @else if (rows().length === 0) {
    <div tuiNotification appearance="info" size="m">No datapoints found for this sport.</div>
  } @else {
    <div class="limit-rows">
      @for (card of metricCards(); track card.key) {
        <article tuiCardMedium appearance="neutral" class="limit-row">
          <app-performance-limits-metric
            [metricName]="card.metricName"
            [datapoints]="card.datapoints"
            [editable]="!readonly()"
            (valueChange)="updateDraft($event)"
            (invalidChange)="setRowInvalid($event)"
          />
        </article>
      }
    </div>
  }
</div>
